export const acceptedFileTypes = [
  'image/*',
  'application/pdf',
  'application/rtf',
  'text/calendar',
  'text/vcard',
  'video/*'
]
export const maxFileSize = '500KB'
export const maxFileSizeLabel = '500 KB'
export const maxFileSizeBytes = 512000

const acceptedFileTypeDetails = {
  'image/*': {
    label: 'Images',
    extensions: '.gif, .jpg, .jpeg, .png, .webp'
  },
  'video/*': {
    label: 'Videos',
    extensions: '.mp4, .mov, .avi, .webm'
  },
  'application/pdf': {
    label: 'PDF',
    extensions: '.pdf'
  },
  'application/rtf': {
    label: 'RTF',
    extensions: '.rtf'
  },
  'text/calendar': {
    label: 'Calendar',
    extensions: '.ics, .cal'
  },
  'text/vcard': {
    label: 'Contact card',
    extensions: '.vcf, .vcard'
  }
}

function getAcceptedFileTypeLabel(type) {
  const details = acceptedFileTypeDetails[type]

  if (!details) {
    return type
  }

  return `${details.label} (${details.extensions})`
}

function formatList(items) {
  if (items.length === 0) {
    return ''
  }

  if (items.length === 1) {
    return items[0]
  }

  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`
  }

  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`
}

export function getAcceptedFileTypesLabel(types = acceptedFileTypes) {
  const labels = types.map(type => getAcceptedFileTypeLabel(type))

  return formatList(labels)
}

export function getAcceptedFileTypeDetails(types = acceptedFileTypes) {
  return types.map(type => {
    const details = acceptedFileTypeDetails[type]

    return {
      type,
      label: details?.label || type,
      extensions: details?.extensions || ''
    }
  })
}

export function getAcceptedFileTypesTooltip(types = acceptedFileTypes) {
  return getAcceptedFileTypeDetails(types)
    .map(({ label, extensions }) => `${label} ${extensions}`.trim())
    .join('\n')
}

export function matchesAcceptedFileType(fileType, types = acceptedFileTypes) {
  if (!fileType || !types?.length) {
    return true
  }

  return types.some(acceptedType => {
    if (acceptedType.endsWith('/*')) {
      return fileType.startsWith(acceptedType.slice(0, -1))
    }

    return fileType === acceptedType
  })
}

export const viewableImgExtensions = ['gif', 'jpg', 'jpeg', 'pjpeg', 'png', 'svg', 'webp']
export const viewableFileExtensions = ['pdf', 'rtf', 'txt', 'cal', 'vcf', 'vcard', '3gp']

export const viewableVideoExtensions = [
  'avi',
  'mp4',
  'm4v',
  'mpg',
  'mpeg',
  'm1v',
  'mpv',
  'ogv',
  'ogx',
  'ogg',
  'spx',
  'ogm',
  'mov',
  'qt',
  'webm',
  'wmv'
]
